import React from "react";
import styled from "styled-components";
import ProductOptionNameTooltip from "./Tooltip";

/**
 * Labels (titles) for PDP options
 *
 * @param {string}  label             Text for the label
 * @param {string}  tooltipHeadLine   Title for optional tooltip
 * @param {string}  tooltipMessage    Message for optional tooltip
 *
 * @returns {Object}
 */
export default function OptionLabel({
  label,
  tooltipHeadLine,
  tooltipMessage,
}) {
  return (
    <OptionNameContainer>
      {(window.is_ab_custom_pdp && <OptionNameAB>{label}</OptionNameAB>) || (
        <OptionName>{label}</OptionName>
      )}
      {tooltipHeadLine && tooltipMessage && (
        <ProductOptionNameTooltip
          tooltipHeadLine={tooltipHeadLine}
          tooltipMessage={tooltipMessage}
        />
      )}
    </OptionNameContainer>
  );
}

const OptionNameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 14px;
  padding-bottom: 8px;
`;
const OptionName = styled.p`
  margin: 0;
  font-size: 14px;
  font-family: "Sofia Pro";
`;

const OptionNameAB = styled.p`
  font-family: Assistant, sans-serif;
  font-weight: 700;
  color: #02455d;
  margin-bottom: 0;
  margin-top: 0;
`;
